<script setup>
import { SIcon } from '@n966/soilbox_ui'

defineProps({
  icon: {
    type: String,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'xl'
  }
})
defineEmits(['click'])
</script>

<template>
  <button
    class="map-button"
    @click="$emit('click')"
  >
    <s-icon
      :name="loading ? 'spinner' : icon"
      :spin="loading"
      :size="size"
      :color="active ? 'var(--primary)' : 'var(--text)'"
    />
  </button>
</template>

<style lang="scss">
.map-button {
  cursor: pointer;
  width: 40px;
  height: 40px;
  background-color: var(--bg);
  border: 1px solid var(--main-bg);
  border-radius: 8px;

  &:hover {
    background-color: var(--bg--hover-dense);
  }

  &:active {
    background-color: var(--bg--active-dense);
  }
}
</style>
